const taxId = value => RegExp(/(\d{9})|(\d{2}-\d{7})/).test(value)

export default taxId
